import React from 'react';
import './main.css';
export default function Prices() {
  return (
    <div>Prices</div>
  )
}
